<template>
  <div>
    <div class="mt-5">
      <v-container v-if="isLoading" type="image" class="loding">
        <v-skeleton-loader type="image"></v-skeleton-loader>
        <v-skeleton-loader type="image"></v-skeleton-loader>
      </v-container>
      <div v-else class="content pb-2">
        <v-stepper v-model="step" alt-labels>
          <v-stepper-header>
            <template v-for="(step, index) in steps">
              <v-stepper-step
                :complete="step > index + 1"
                :step="index + 1"
                :key="'step' + index"
              >
                {{ step.label }}
              </v-stepper-step>
              <v-divider
                v-if="index < steps.length - 1"
                :key="'divider' + index"
              ></v-divider>
            </template>
          </v-stepper-header>

          <div class="stepper-content">
            <component
              v-if="devisObjectLoaded"
              :operation="operation"
              :is="currentStepComponent"
              :progress="progress"
              :produitIds="produitIds"
              :isLoadingButton="isLoadingButton"
              @changeStepPrev="handleStepChangePrv"
              @changeStep="handleStepChange"
            ></component>
          </div>
        </v-stepper>

        <div class="justify-content-end">
          <v-snackbar
            :timeout="2000"
            v-model="Valid"
            color="blue-grey"
            rounded="pill"
          >
            &#x2705; {{$t('Modification_succès')}}
          </v-snackbar>
        </div>
        <div class="justify-content-end">
          <Snackbar ref="snackbar" class="mt-5" />
          <!-- <v-snackbar
            :timeout="2000"
            v-model="Err"
            color="blue-grey"
            rounded="pill"
          >
          
            &#x274C; {{$t('Vérifiez vos données.')}}
          </v-snackbar> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Snackbar from "@/components/ui/errorSnackbar.vue";

export default {
  components:{
    Snackbar,

  },
  data() {
    return {
      Err: false,
      Valid: true,
      isLoading: true,
      progress: false,
      isLoadingButton: false,
      step: 1,
      produitIds: [],
      devisObjectLoaded: false,
    };
  },
  props: {
    operation: {
      type: Boolean,
      default: false,
    },
    steps: {
      type: Array,
      required: true,
    },
  },
  watch: {
    $route() {
      this.handleRouteChange();
    },
  },

  created() {
    this.handleRouteChange();
    this.isLoading = false;
  },
  computed: {
    ...mapGetters(["getdevisMonoFiche"]),
    currentStepComponent() {
      return this.steps[this.step - 1].component;
    },
  },

  methods: {
    ...mapActions([
      "updatedevisMonoFiche",
      "getoneMonodevis",
      "setDevisMonoFiche",
    ]),
    async handleRouteChange() {
      const id = this.$route.params.id;
      if (id) {
        await this.fetchDevisObject(id);
      }
    },
    handleStepChangePrv(newStep) {
      
      this.step = newStep;
    },
 

    async fetchDevisObject(id) {
      const fetchedDevisObject = await this.getoneMonodevis(id);
      console.log('rfrr')
      // Si configuration_id n'est pas null, le devis reste non signé (pas mis à jour en brouillon)
      const configId = fetchedDevisObject?.data?.devis?.configuration_id ?? fetchedDevisObject?.data?.document?.configuration_id;
      if (configId == null) {
        fetchedDevisObject.data.devis.brouillon = 1;
        if (fetchedDevisObject.data.brouillon !== undefined) fetchedDevisObject.data.brouillon = 1;
      }
      await this.setDevisMonoFiche(fetchedDevisObject);

      this.devisObjectLoaded = true;
      const produitIds =
        this.getdevisMonoFiche?.data.GroupeLigneDocument_produit.filter(
          (item) => item.produit_id
        ).map((item) => item.produit_id);
      this.produitIds = produitIds;

      if (this.fetchedDevisObject) {
        this.isLoading = false;
      }
    },
    async valideDevis(getdevisMonoFiche) {

    
      if (
        getdevisMonoFiche.data.devis.client &&
        getdevisMonoFiche.data.devis.logement &&
       
        (getdevisMonoFiche.data.devis.partenaire ||
          getdevisMonoFiche.data.devis.mandataire) &&
        getdevisMonoFiche.data.devis.debut_devis &&
        getdevisMonoFiche.data.devis.fin_devis &&
        getdevisMonoFiche.data.devis.visite_technique
      
      ) {
        console.log('getdevisMonoFiche.data.devis.debut_devis',getdevisMonoFiche.data.devis.debut_devis)
        console.log('getdevisMonoFiche.data.devis.partenaire',getdevisMonoFiche.data.devis.partenaire)
        console.log(' getdevisMonoFiche.data.devis.mandataire', getdevisMonoFiche.data.devis.mandataire)
        console.log('getdevisMonoFiche.data.devis.fin_devis',getdevisMonoFiche.data.devis.fin_devis)
    console.log('getdevisMonoFiche.data.devis.visite_technique',getdevisMonoFiche.data.devis.visite_technique)
       console.log('getdevisMonoFiche.data.devis.brouillon',getdevisMonoFiche.data.devis)
          getdevisMonoFiche.data.devis.brouillon = 0;
          getdevisMonoFiche.data.brouillon = 0;
          await this.setDevisMonoFiche(getdevisMonoFiche);
                  await new Promise(resolve => setTimeout(resolve, 500));

      } else {
         console.log('getdevisMonoFiche.data.devis.signature',getdevisMonoFiche.data.devis)
        // Si configuration_id n'est pas null, le devis reste non signé (pas mis à jour en brouillon)
        const configId = getdevisMonoFiche?.data?.devis?.configuration_id ?? getdevisMonoFiche?.data?.document?.configuration_id;
        if (configId == null) {
          getdevisMonoFiche.data.devis.brouillon = 1;
          getdevisMonoFiche.data.brouillon = 1;
        }
        await this.setDevisMonoFiche(getdevisMonoFiche);
      }
      console.log('  this.getdevisMonoFiche.data.devis',  this.getdevisMonoFiche.data.devis)

    },
    async updatedevis() {
            console.log(' 000',  this.getdevisMonoFiche.data.devis)

      const reponse = await this.updatedevisMonoFiche(
        this.getdevisMonoFiche.data.devis
      );
      return reponse;
    },
       async handleStepChange(newStep, loader) {
      this.isLoadingButton = loader;
      this.progress = true;

      // Limiter le changement d'étape à une différence de 1
      const stepDifference = Math.abs(newStep - this.step);
      if (stepDifference > 1) {
        newStep = newStep > this.step ? this.step + 1 : this.step - 1;
      } else if (stepDifference === 0 && newStep > 1) {
        newStep = this.step - 1;
      }

      try {
        console.log('rrr')
        const result = await this.updatedevis();
        console.log('result77',result)
        if (!result.status) {
          console.log('result77',result)
          this.$refs.snackbar.showSnackbar(result);

          this.Err = true;
          this.Valid = false;
          return;
        }
        this.Valid = true;
        this.Err = false;
     console.log('newStep0',newStep)
        if (newStep === 7) {
                  const id = this.$route.params.id;

          const fetchedDevisObject = await this.getoneMonodevis(id);
  fetchedDevisObject.data.devis.brouillon = 0;
          fetchedDevisObject.data.brouillon = 0;
          console.log('fetchedDevisObject11',fetchedDevisObject)
          await this.setDevisMonoFiche(fetchedDevisObject);
      const result = await this.updatedevis();
      console.log('result99',result)
       
        
        }
         if (newStep === 8) {
                  const id = this.$route.params.id;

          const fetchedDevisObject = await this.getoneMonodevis(id);
  fetchedDevisObject.data.devis.brouillon = 0;
          fetchedDevisObject.data.brouillon = 0;
          console.log('fetchedDevisObject11',fetchedDevisObject)
          await this.setDevisMonoFiche(fetchedDevisObject);
      await this.updatedevis();
        const documentType = fetchedDevisObject?.data?.devis?.type;
        const typeFacture = fetchedDevisObject?.data?.devis?.typeFacture;
        if (documentType === "facture" && typeFacture === "facture.fin-travaux") {
          this.$router.push("/gestion-dossiers");
        } else if (documentType === "facture" && typeFacture === "facture.acompte") {
          this.$router.push("/gestion-dossiers");
        } else {
          this.$router.push("/gestion-dossiers");
        }
          return;
        }
        if (this.step === 6||this.step===1) {
          const id = this.$route.params.id;

          const fetchedDevisObject = await this.getoneMonodevis(id);
                  await new Promise(resolve => setTimeout(resolve, 500));

         await this.valideDevis(fetchedDevisObject);
       
        }
        console.log('Setting step from', this.step, 'to', newStep);
        this.step = newStep;
      } catch (error) {
        this.Err = true;
      } finally {
        this.isLoadingButton = false;
        this.progress = false;
      }
    },
  },
};
</script>

<style lang="scss">
.v-stepper__step--complete .v-stepper__step__step {
  background-color: #24316d !important;
  border-color: #24316d !important;
  color: white !important;
}

.v-stepper__step--active .v-stepper__step__step {
  background-color: #24316d !important;
  border: 1px solid #24316d !important;
  color: white !important;
  box-shadow: 0 0 0 1px #fff inset;
  border-radius: 50%;
}

.v-stepper__step--complete + .v-divider {
  border-color: #24316d !important;
}

.v-divider {
  border-color: rgba(0, 0, 0, 0.12);
}

::before {
  text-decoration: inherit;
  vertical-align: inherit;
  color: white !important;
}
.v-stepper__header {
  height: 72px;
  align-items: stretch;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  box-shadow: none !important;
}
.theme--light.v-stepper .v-stepper__step--active .v-stepper__label {
  text-shadow: 0px 0px 0px black;
  color: #24316d !important;
}

.theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {
  text-shadow: 0px 0px 0px black;
  color: #24316d !important;
}

.v-sheet.v-stepper:not(.v-sheet--outlined) {
  box-shadow: none !important;
}

.button-pre-style,
.button-suivant-style {
  background-color: #24316d;
  color: white;
  font-size: 13px;
  box-shadow: none !important;
}

.button-suivant-style:hover,
.button-suivant-style:focus,
.button-suivant-style:active {
  background-color: #24316d;
  color: white;
}

/* Responsive Styles */
@media only screen and (max-width: 1200px) {
  .v-stepper__step--complete .v-stepper__step__step,
  .v-stepper__step--active .v-stepper__step__step {
    font-size: 12px;
  }

  .stepper-buttons {
    flex-direction: column;
    align-items: center;
  }

  .button-pre-style,
  .button-suivant-style {
    font-size: 16px;
    padding: 8px 16px;
  }
}

@media only screen and (max-width: 530px) {
  .v-stepper__step--complete + .v-divider {
    border-color: white !important;
  }
  .v-stepper--alt-labels .v-stepper__step {
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    flex-basis: 75px;
  }
  .theme--light.v-stepper .v-stepper__header .v-divider {
    border-color: #fff;
  }

  .v-divider {
    display: block;
    height: 0px;
    max-height: 0px;
    border: solid;
    border-width: thin 0 0 0;
    transition: inherit;
  }
  .v-stepper--alt-labels .v-stepper__step {
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }

  .v-stepper__step {
    align-items: center;
    display: flex;
    flex-direction: row;
  }
}
@media only screen and (max-width: 900px) {
  .v-stepper__step--complete .v-stepper__step__step,
  .v-stepper__step--active .v-stepper__step__step {
    font-size: 10px;
  }

  .stepper-buttons {
    flex-direction: column;
    align-items: center;
  }

  .button-pre-style,
  .button-suivant-style {
    font-size: 10px;
    padding: 6px 12px;
  }
}

@media only screen and (max-width: 600px) {
  .v-stepper__step--complete .v-stepper__step__step,
  .v-stepper__step--active .v-stepper__step__step {
    font-size: 8px;
  }

  .stepper-buttons {
    flex-direction: column;
    align-items: center;
  }

  .button-pre-style,
  .button-suivant-style {
    font-size: 8px;
    padding: 4px 8px;
  }
}

.stepper-content {
  padding: 0 10px;
}
</style>
